"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Link.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BarChart = require("@mui/x-charts/BarChart");
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : KpiBars.js
* Description : Ce fichier contient la définition du composant KpiBars 
*               Ce composant est un BarChart personnalisé de la librairie MuiMaterial
* Date de création : 3 aout 2026
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* KpiBars : ce composant est un BarChart personnalisé de la librairie MuiMaterial
*
* Type : composant 
*
* Parametres : 
*  - children -- texte affiché sur le lien
*  - path -- Url de la page à renvoyer
*/function KpiBars(_ref) {
  var dataset = _ref.dataset,
    graphHeight = _ref.graphHeight;
  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarChart.BarChart, {
      dataset: dataset,
      xAxis: [{
        dataKey: 'year',
        type: 'band',
        scaleType: 'band'
      }],
      series: [{
        dataKey: 'value',
        label: 'Nombre d\'essais',
        type: 'bar',
        barLabel: 'value'
      }],
      height: graphHeight + 38
    })
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
KpiBars.propTypes = {
  colorLabel: _propTypes["default"].string
};
var _default = exports["default"] = KpiBars;